// extracted by mini-css-extract-plugin
export default {"emptyDescription":"Filling_emptyDescription__BzGX8","link":"Filling_link__9gfs2","flex":"Filling_flex__grkLi"};